import { GET_DEVICE } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_DEVICE:
            return action.payload;
        default:
            return state;
    }
}
